import { OnboardingDetailsRole, OnboardingDetailsType } from '@nemuru-eng/js-api-client';

import { ENV_CHECKOUT_B2B_URL, ENV_HPP_URL, ENV_NEMURU_BORROWER_URL, ENV_NEMURU_PAYBYLINK_URL } from '@/config/envVars';
import { ApplicationType } from '@/config/types';

export const getPathByApplicationType = ({
  applicationType,
  id,
  participant,
}: {
  applicationType: ApplicationType;
  id: string;
  participant: {
    type: OnboardingDetailsType;
    role: OnboardingDetailsRole;
    onboardingDetailsId?: string;
  };
}) => {
  const { type, role, onboardingDetailsId } = participant;
  switch (applicationType) {
    case ApplicationType.AUTO: {
      if (type === OnboardingDetailsType.BUSINESS && role === OnboardingDetailsRole.BORROWER)
        return `${ENV_CHECKOUT_B2B_URL}?id=${id}`;

      return `${ENV_NEMURU_BORROWER_URL}application/${id}${onboardingDetailsId ? `?oid=${onboardingDetailsId}` : ''}`;
    }
    case ApplicationType.CONSUMER_LOAN:
    case ApplicationType.CREDIT_LINE:
      return `${ENV_NEMURU_BORROWER_URL}application/${id}${onboardingDetailsId ? `?oid=${onboardingDetailsId}` : ''}`;
    case ApplicationType.PAY_BY_LINK:
      return `${ENV_NEMURU_PAYBYLINK_URL}?id=${id}`;
    case ApplicationType.CARD:
      return `${ENV_HPP_URL}/${id}`;
    default:
      break;
  }
};
